import { render, staticRenderFns } from "./TableBlueLabelIp.vue?vue&type=template&id=51e83c52&scoped=true&"
import script from "./TableBlueLabelIp.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelIp.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelIp.vue?vue&type=style&index=0&id=51e83c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e83c52",
  null
  
)

export default component.exports